import styled from 'styled-components';
import { ReactComponent as CloseIcon } from './close.svg';

export const ModalWindow = styled.div`
  border-radius: 16px;
  width: 800px;
`;

export const Header = styled.div`
  border-radius: 16px 16px 0 0;
  background-color: #1cc67f;
  padding: 16px 24px;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
  color: #fff;
  position: relative;
`;

export const Main = styled.div`
  border-radius: 0 0 16px 16px;
  background-color: #fff;
  padding: 16px 24px 24px;
`;

export const GrayZone = styled.div`
  padding: 24px;
  border-radius: 16px;
  background: #f4f5f6;
`;

export const Actions = styled.div`
  display: flex;
  position: relative;
`;

export const Text = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.85);
  a,
  a:hover,
  a:active,
  a:visited {
    color: #12b7e7;
  }
`;
export const Copied = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 40px;
  padding: 11px 24px;
  border-radius: 68px;
  background: rgba(9, 21, 38, 0.6);
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
`;
export const SocialIcon = styled.a<{ bg: string; bgHover: string }>`
  display: block;
  width: 40px;
  height: 40px;
  background: url(${(props) => props.bg});
  &:hover {
    background: url(${(props) => props.bgHover});
  }
`;

export const Close = styled(CloseIcon)`
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
`;

export const TitleMain = styled.div`
  color: rgba(9, 21, 38, 0.6);
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
`;
